<template>
	<div class="container">
		<!--  顶部搜索  -->
		<search-bar></search-bar>
		<div class="main-body g-flex g-row-center g-m-t-20">
			<div class="total-width">
				<!--  菜单/轮播  -->
				<div class="g-flex menu-swiper">
					<!--  菜单  -->
					<left-menu></left-menu>
					<div class="g-full-width g-rela g-m-l-20">
						<!--  轮播  -->
						<el-carousel arrow="never">
							<el-carousel-item v-for="(item,index) in imgList" :key="index">
								
								<a :href="item.target" target="_blank" v-if="item.type==''&&item.target!=''">
									<img :src="item.imageUrl" class="swiper-img" alt="">
								</a>
								<a v-if="item.type==''&&item.target==''">
									<img :src="item.imageUrl" class="swiper-img" alt="">
								</a>
								<a :href="'/#/course-detail/'+item.target" target="_blank" v-if="item.type=='course'">
									<img :src="item.imageUrl" class="swiper-img" alt="">
								</a>
								<a :href="'/#/store-detail?id='+item.target" target="_blank" v-if="item.type=='clinic'">
									<img :src="item.imageUrl" class="swiper-img" alt="">
								</a>
								<a :href="'/#/job-detail?id='+item.target" target="_blank" v-if="item.type=='demand'">
									<img :src="item.imageUrl" class="swiper-img" alt="">
								</a>
								<a :href="'/#/examination-detail?id='+item.target" target="_blank" v-if="item.type=='exam'">
									<img :src="item.imageUrl" class="swiper-img" alt="">
								</a>
							</el-carousel-item>
						</el-carousel>
						<!--  已登录/未登录  -->
						<div class="g-abso login-box" v-if="!getLoginState">
							<login-card></login-card>
						</div>
						<!--  登陆  -->
						<div class="g-abso login-box" v-else>
							<user-card v-if="getUserRole.indexOf('HR')===-1"></user-card>
						</div>
					</div>
				</div>
				<!--  广告/职位，职位展示10条 -->
				<div class="g-flex g-row-between g-m-t-30 g-col-top">
					<!--  左侧广告位 和 职位列表下标0的数据  -->
					<div class="ad-box">
						<img src="@/assets/home/ad-img.png" class="ad-img pointer" alt="" @click="gotoJobList()">
						<!-- 职位列表的第一条数据 -->
						<div class="g-m-t-10">
							<job-position-card></job-position-card>
						</div>
					</div>
					<!--  右侧职位分类/列表  -->
					<div class="g-full-width g-m-l-25">
						<!--  职位分类  -->
						<div class="job-title-list g-flex g-row-between">
							<el-tabs v-model="jobTitleIndex" @tab-click="jobTitleChange">
								
								<el-tab-pane :label="item.postName" :value="item.id" v-for="(item,index) in jobTitleList"
									:key="index"></el-tab-pane>
							</el-tabs>
							<p class="sub-text g-font-14 g-m-l-30" @click="gotoJobList">查看更多职位 <i class="el-icon-arrow-right"></i></p>
						</div>
						<!--  职位列表 从下标1开始循环9个  -->
						<div class="job-list g-flex g-row-between g-flex-wrap">
							<div class="g-m-t-14" v-for="(item,index) in jobList" :key="index">
								<job-position-card :item="item"></job-position-card>
							</div>
							<div style="width:18rem;" v-if="jobList.length%3>0" v-for="index in 3-jobList.length%3" :key="index"></div>
						</div>
					</div>
				</div>
				<!--  口腔专业人才库 8条 -->
				<!-- <div v-if="isClinic">
					<div class="g-m-t-40 g-flex g-row-center">
						<img src="@/assets/home/title-left.png" class="title-img" alt="">
						<p class="g-font-28 g-font-weight-7 g-p-l-30 g-p-r-30">口腔专业人才库</p>
						<img src="@/assets/home/title-right.png" class="title-img" alt="">
					</div>
					<div class="g-flex g-row-between g-flex-wrap">
						<div class="g-m-t-60" v-for="(item,index) in careerList" :key="index">
							<applicant-card-home :item="item"></applicant-card-home>
						</div>
					</div>
					<div class="g-flex g-row-center" v-if="!skipCareers">
						<div class="submit-btn g-m-t-30" @click="gotoCareerList">查看更多人才</div>
					</div>
				</div> -->
				

				<!--  技能考核认证 7条 -->
				<div class="g-m-t-40 g-flex g-row-center">
					<img src="@/assets/home/title-left.png" class="title-img" alt="">
					<p class="g-font-28 g-font-weight-7 g-p-l-30 g-p-r-30">技能考核认证</p>
					<img src="@/assets/home/title-right.png" class="title-img" alt="">
				</div>
				<div class="g-flex g-row-between g-flex-wrap">
					<div class="g-m-t-30" v-for="item in examList" :key="item.id">
						<test-card :data="item"></test-card>
					</div>
					<img src="@/assets/home/ad-2.png" alt="" class="ad-2 g-m-t-30 pointer" @click="gotoExamination">
				</div>

				<!--  认证人才/机构 -->
				<div class="g-flex g-row-between g-m-t-30">
					<img src="@/assets/home/ad-3.png" class="ad-3 pointer" alt="" @click="gotoRegisterA">
					<img src="@/assets/home/ad-4.png" class="ad-3 pointer" alt="" @click="gotoRegister">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import store from "@/store"
	import searchBar from "@/components/search-bar";
	import leftMenu from "@/views/home/components/left-menu";
	import loginCard from "@/views/home/components/login-card";
	import userCard from "@/views/home/components/user-card";
	import JobPositionCard from "@/views/home/components/job-position-card";
	import ApplicantCardHome from "@/components/applicant-card-home";
	import TestCard from "@/components/test-card";
	import {getPageList} from "@/api/education/paper";
	import {
		jobList,
		portalList,
		getTalentList
	} from "@/api/job.js"
	import {
		getCarousel
	} from "@/api/home.js"
	export default {
		name: "home",
		components: {
			TestCard,
			JobPositionCard,
			userCard,
			searchBar,
			leftMenu,
			loginCard,
			ApplicantCardHome
		},
		data() {
			return {
				jobTitleList:[],
				jobList:[],
				jobTitleIndex: 0, //职位分类列表索引
        examList:[],
				hasLogin: false, //是否登录
				params: {
					current: 1,
					size: 6,
					postId:''
				},
				imgList:[],
				careerList:[]
			}
		},
		computed: {
			getLoginState() {
				console.log('!!!!!!!!!',this.$store.state.isLogin)
				return this.$store.state.isLogin

			},
			getUserRole() {
				return this.$store.state.userInfo.role_name
			},
			skipCareers(){
				return !this.$store.state.isLogin||!this.$store.state.userInfo.clinic_id||this.$store.state.userInfo.clinic_id==-1;
			},
			isClinic(){
				return this.$store.state.isLogin&&(this.$store.state.userInfo.clinic_id!=''&&this.$store.state.userInfo.clinic_id!=-1)
			},
			isCustomer(){
				return this.$store.state.isLogin&&(this.$store.state.userInfo.clinic_id==''||this.$store.state.userInfo.clinic_id==-1)
			}
		},
		mounted() {
			history.pushState(null, null, document.URL);
			window.addEventListener("popstate", function() {
				history.pushState(null, null, document.URL);
			});
			this.getJobList()
			this.getCareerList()
			this.getPortalList()
			this.getImgList()
      this.getExamList()
		},
		methods: {
			getCareerList() {
				getTalentList(this.params).then(res=>{
					this.careerList=res.records
				})
			},
			getImgList(){
				getCarousel({
					classification:'portal',
					status:2
				}).then(res=>{
					this.imgList=res.records
				})
			},
			getPortalList(){
				portalList({}).then(res => {
					console.log('getPortalList',res)
					this.jobTitleList=res.slice(0,5)
					this.jobTitleList.unshift({postName:'全部',id:''})
				})
			},
      getExamList() {
			  let params={
            size:7,
            current: 1,
        };
        getPageList(params).then(res=>{
            if(res.records.length<7&&res.records.length>3){
              res.records.forEach((item,index)=>{
                if(index<3){
                  this.examList.push(item);
                }
              })
            }else {
              this.examList=res.records
            }
        })
      },
      getJobList() {
				jobList(
					this.params
				).then(res => {
					console.log('res',res)
					this.jobList=res.records
				})
			},
			jobTitleChange() {
				// 当前选择的tab
				console.log(this.jobTitleList[this.jobTitleIndex])
				this.params.postId=this.jobTitleList[this.jobTitleIndex].id
				this.getJobList()
			},
			gotoJobList(){
				this.$router.push({
					name: 'find-job',
				})
			},
			gotoCareerList(){
				this.$router.push({
					name: 'find-careers',
				})
			},
			gotoExamination(){
				this.$router.push({
					name: 'examination',
				})
			},
			gotoRegisterA(){
				if(this.$store.state.isLogin){
					this.$router.push({
						name: 'mine',
					})
				}else{
					this.$router.push({
						name: 'login',
					})
				}
				
			},
			gotoRegister(){
				/*this.$router.push({
					name: 'login',
					query:{tabIndex:'2'}
				})*/
				window.location.href = 'https://admin.yzhkq.com/'
			}
		}
	}
</script>

<style lang="scss" scoped>
	.menu-swiper {
		align-items: stretch;

		.swiper-img {
			width: 100%;
			display: block;
		}

		::v-deep .el-carousel .el-carousel--horizontal {
			height: 386px;
		}

		::v-deep .el-carousel__container {
			height: 386px;
		}
	}

	::v-deep .el-carousel__button {
		padding: 0 !important;
		width: 8px;
		height: 8px;
		border-radius: 50%;
	}

	::v-deep .el-carousel__indicator.is-active button {
		width: 20px !important;
		border-radius: 20px;
	}

	.login-box {
		z-index: 97;
		right: 25px;
		// top: 25px;
		top: 20px;//放下通知公告
	}

	.ad-box {
		width: 385px;

		.ad-img {
			width: 100%;
			display: block;
			height: 352px;
		}
	}

	.job-title-list {
		background: #ffffff;
		border-radius: 5px;
		padding: 0 30px;

		::v-deep .el-tabs__header {
			margin: 0 !important;
		}

		::v-deep .el-tabs__nav-wrap::after {
			background: #fff;
		}

		::v-deep .el-tabs__item {
			height: 50px;
			line-height: 50px;
			font-size: 16px;
		}

		::v-deep .el-tabs__active-bar {
			height: 3px;
			font-size: 16px;
		}
	}

	.title-img {
		width: 91px;
		height: 20px;
		display: block;
	}

	.submit-btn {
		padding: 13px 52px;
	}

	.ad-2 {
		width: 288px;
		height: 370px;
		display: block;
	}

	.ad-3 {
		width: 590px;
		height: 150px;
		display: block;
	}
</style>
